
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar} from 'react-bootstrap'
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import ReactPaginate from 'react-paginate';
import { Box } from 'reactjs-admin-lte'
import HrStore from '../../stores/HrStore'
import ContractorEditModal from './ContractorEditModal'
import ReportCustomerHistoryModal from '../report/ReportCustomerHistoryModal'

class ContractorPage extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,showEdit:false,showHistory:false,catSelect:null,curPage:0,pageCount:0,query:'',catOptions:[],tableData:[]}

    
  }

  componentDidMount(){
    this.loadContractorList()
  }

 

  loadContractorList(query='',pageNo=''){
    this.setState({loading:true})
    let that = this
    HrStore.loadContractorList(query,pageNo,function(result){
      that.setState({tableData:result.data,pageCount:result.totalPage,loading:false})
    })
  }

  onHide(){

  }

  

  onTextChange(e){
    let {catSelect} = this.state
    let query = e.target.value
    let loading = false
    if(typeof query!=='undefined' && query.length>2){
      
      this.loadContractorList(query);
            
    }
    this.setState({query:query})
    
  }

  onNewClick(){
    this.refs.wageitemedit.loadItemcode(null)
    this.setState({showEdit:true})
  }

  onEditClick(item){
    this.refs.wageitemedit.loadItemcode(item)
    this.setState({showEdit:true})
  }

  onHistoryClick(item){
    this.refs.customerHist.loadHistory(item)
    this.setState({showHistory:true})
  }

  onRowClick(item){
    
    //this.props.onSelect(item)
    if(typeof this.props.onSelectItem!=='undefined')
      this.props.onSelectItem(item)
  }

  onClearClick(){
    this.setState({query:'',curPage:0,catSelect:null})
    this.loadContractorList()
  }

  onAfterSubmit(postData){
    this.onClearClick()
  }

  onPageChange(page){
    console.log('Change page to ',page)
    let {query} = this.state

    
    this.loadContractorList(query,page.selected)

    this.setState({curPage:page.selected})
  }

  renderSearch(){
    let {query,catSelect,catOptions} = this.state
    let {showNew} = this.props
    if(typeof showNew=='undefined'){
      showNew = true
    }
    return (
      <div className='row form-group'>
        <div className='col-md-8' style={{display:'inline-flex'}}>
          <FormControl value={query} placeholder='ชื่อช่าง' onChange={this.onTextChange.bind(this)}/>
          <ButtonToolbar style={{width:'450px',marginLeft:'10px'}}>
            <Button onClick={this.onClearClick.bind(this)}><FontAwesome name="eraser"/>&nbsp;ลบการค้นหา</Button>            
          </ButtonToolbar>
        </div> 

      </div>
    )
  }

  renderRowData(){
    let {tableData} = this.state
    return tableData.map((item,index)=>(
      <tr key={index}>
        <td  onClick={this.onRowClick.bind(this,item)}>{index+1}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.employee_id}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.first_name}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.last_name}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.nick_name}</td>
        <td  onClick={this.onRowClick.bind(this,item)} >{item.position}</td>
        <td className='text-center'>
          <ButtonToolbar>
            <Button style={{diplay:'none'}} onClick={this.onHistoryClick.bind(this,item)}>ประวัติ</Button>            
          </ButtonToolbar>
        </td>
      </tr>
    )) 
  }

  renderSearchResult(){
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th>#ID</th>
            <th>#รหัสพนักงาน</th>
            <th>ชื่อ</th>
            <th>นามสกุล</th>   
            <th>ชื่อเล่น</th>            
            <th>ตำแหน่ง</th>
            <th>ดูประวัติ/แก้ไข</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        
      </table>
    )
  }


  renderPaging(){
    let {pageCount} = this.state
    if(pageCount>0){
      return (
        <div className="commentBox">        
          <ReactPaginate  
                        previousLabel={"ก่อนหน้า"}
                        nextLabel={"ถัดไป"}
                        breakLabel={<a href="">...</a>}
                        breakClassName={"break-me"}
                        pageCount={this.state.pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={this.onPageChange.bind(this)}
                        containerClassName={"pagination pull-right"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
        </div>
      ); 
    } else{
      return (<div/>)
    }
  }

  render(){
    let {show} = this.props
    let {loading,showEdit,showHistory,catOptions} = this.state
    return (
      <div>
          <Box loading={loading}>            
            <Box.Body>
              {this.renderSearch()}
              {this.renderSearchResult()}
              {this.renderPaging()}
            </Box.Body>
          </Box>    
          <ReportCustomerHistoryModal ref='customerHist' show={showHistory} 
          onHide={()=>{this.setState({showHistory:false})}}
          />      
          <ContractorEditModal  ref={'wageitemedit'} show={showEdit} 
          catOptions={catOptions} 
          onAfterSubmit={this.onAfterSubmit.bind(this)}
          onHide={()=>{this.setState({showEdit:false})}}/>
      </div>
    )
  }
}


export default ContractorPage;





// WEBPACK FOOTER //
// ./src/view/hr/ContractorPage.js